<cp-svg-icon-definition *ngFor="let systemIcon of systemIcons" [svgIcon]="systemIcon"></cp-svg-icon-definition>
<cp-svg-icon-definition *ngFor="let siteSvgIcon of siteSvgIcons" [svgIcon]="siteSvgIcon"></cp-svg-icon-definition>
<cp-svg-icon-definition *ngFor="let patientPic of patientPictureIcons" [svgIcon]="patientPic"></cp-svg-icon-definition>
